/**
 * type guard function to check if an Action is a BaseCompAction
 * @param action
 * @returns
 */
export const isBaseCompAction = (action) => {
    return action.onClick !== undefined;
};
/**
 * type guard function to check if an Action is a BaseCompSubAction
 * @param action
 * @returns
 */
export const isBaseCompSubAction = (action) => {
    return action.actions instanceof Array;
};
